module.exports = __webpack_public_path__ + "img/katarina_bathrooms_7.d1d214a9.jpg";